import {
  EXISTANCE_FLAG,
  EXISTANCE_EXCLUSION_FLAG,
  AcceptanceForeignWorkersFlag,
  PREFECTURE_GROUPS,
} from './constants';
import _ from 'lodash';
import moment from 'moment';
import { isNullOrUndefinedOrEmptyStr } from './stringUtil';
import dialogLoader from './dialogLoader';
import { FormInformationDialog } from '../components/FormInformationDialog';

/**
 * 会社情報編集_労務安全項目(PartnerCompanySafty)、
 * 会社情報編集本社情報(PrimeCompany)の労務安全系で使用
 *
 * 上記ComponentでのstateやAPI、が他Componentの労務安全系と一致しているか不明。
 */

export const INSURANCE_STATUS = 'INSURANCE_STATUS';
export const HEALTH_INSURANCE_FLAG = 'health_insurance_flag';
export const PENSION_FLAG = 'pension_flag';
export const CONSTRUCTION_INDUSTRY_PERMISSION_FLAG =
  'construction_industry_permission_flag';
export const EMPLOYMENT_INSURANCE_FLAG = 'employment_insurance_flag';
export const WORKER_COMPENSATION_FLAG = 'worker_compensation_flag';
export const CONST_SUBSCRIPTION_FLAG = 'const_subscription_flag';
export const ENTERPRISE_SUBSCRIPTION_FLAG = 'enterprise_subscription_flag';
export const OTHER_SUBSCRIPTION_FLAG = 'other_subscription_flag';
export const ACCEPTANCE_FOREIGN_WORKERS_FLAG =
  'acceptance_foreign_workers_flag';

/**
 * これらの値はAPIからのデータ準拠
 * 各種保険情報の有、適用除外、無。未選択の可能性もある
 */
export const PRESENCE = 'PRESENCE'; // 有
export const EXCLUSION = 'EXCLUSION'; // 適用除外
export const NONE = 'NONE'; // 無

// 建退共制度加入、中退共制度
export const NOT_JOINED = 'NOT_JOINED';
export const JOIN = 'JOIN';

// 有の場合trueを返す
export const isConstructionIndustryPermissionStatus = constructionIndustryPermissionFlag => {
  return (
    String(constructionIndustryPermissionFlag) ===
    String(EXISTANCE_FLAG.EXIST.VALUE)
  );
};

export const isSecurityCompanyPermissionStatus = securityCompanyPermissionFlag => {
  return (
    String(securityCompanyPermissionFlag) === String(EXISTANCE_FLAG.EXIST.VALUE)
  );
};

export const isOtherSubscriptionStatus = OtherSubscriptionFlagValue => {
  return (
    String(OtherSubscriptionFlagValue) === String(EXISTANCE_FLAG.EXIST.VALUE)
  );
};

export const isAcceptanceForeignWorkersStatus = AcceptanceForeignWorkersFlagValue => {
  return (
    String(AcceptanceForeignWorkersFlagValue) ===
    String(AcceptanceForeignWorkersFlag.Accept.id)
  );
};

export const isWorkerAddOnCompensationStatus = workerAddOnCompensationFlag => {
  return (
    String(workerAddOnCompensationFlag) === String(EXISTANCE_FLAG.EXIST.VALUE)
  );
};

export const isOtherIndustryPermissionStatus = otherIndustryPermissionFlag => {
  return (
    String(otherIndustryPermissionFlag) === String(EXISTANCE_FLAG.EXIST.VALUE)
  );
};

/**
 * 会社情報編集_労務安全項目と会社情報編集本社情報で使用
 * 健康、年金、雇用保険の安全書類項目制御条件が共通でなくなったら別々にする
 *
 *  プレビュー時、読み込みが完了していない時は全てfalse
 */
export const getInsuranceStatus = ({
  selectedHealthInsurance,
  selectedPensionInsurance,
  selectedEmploymentInsurance,
}) => {
  const insuranceStatus = {
    healthPresence: false, // 健康保険加入状況：有りが選択されていたらtrue
    healthExclusion: false, // 健康保険加入状況：適用除外が選択されていたらtrue
    pensionPresence: false,
    pensionExclusion: false,
    employmentPresence: false,
    employmentExclusion: false,
  };

  if (selectedHealthInsurance) {
    insuranceStatus.healthPresence = statusMatchWithExclusion(
      PRESENCE,
      selectedHealthInsurance.key
    );
    insuranceStatus.healthExclusion = statusMatchWithExclusion(
      EXCLUSION,
      selectedHealthInsurance.key
    );
  }

  if (selectedPensionInsurance) {
    insuranceStatus.pensionPresence = statusMatchWithExclusion(
      PRESENCE,
      selectedPensionInsurance.key
    );
    insuranceStatus.pensionExclusion = statusMatchWithExclusion(
      EXCLUSION,
      selectedPensionInsurance.key
    );
  }
  if (selectedEmploymentInsurance) {
    insuranceStatus.employmentPresence = statusMatchWithExclusion(
      PRESENCE,
      selectedEmploymentInsurance.key
    );
    insuranceStatus.employmentExclusion = statusMatchWithExclusion(
      EXCLUSION,
      selectedEmploymentInsurance.key
    );
  }
  return insuranceStatus;
};

// 労災保険特別加入状況
export const getWorkmansCompensationInsuranceStatus = selectedStatus => {
  if (selectedStatus) {
    return {
      presence: statusMatchByWorkmansCompensationInsurance(
        selectedStatus.key,
        PRESENCE
      ),
      exclusion: statusMatchByWorkmansCompensationInsurance(
        selectedStatus.key,
        EXCLUSION
      ),
    };
  } else {
    return {
      presence: false,
      exclusion: false,
    };
  }
};

// 建退共制度加入状況
export const getKentaikyoInsuranceStatus = selectedStatus => {
  if (selectedStatus) {
    return {
      presence: statusMatchByKentaikyoInsurance(selectedStatus.key, JOIN),
      exclusion: statusMatchByKentaikyoInsurance(
        selectedStatus.key,
        NOT_JOINED
      ),
    };
  } else {
    return {
      presence: false,
      exclusion: false,
    };
  }
};

// 中退共制度加入状況
export const getChutaikyoInsuranceStatus = selectedStatus => {
  if (selectedStatus) {
    return {
      presence: statusMatchByChutaikyoInsurance(selectedStatus.key, JOIN),
      exclusion: statusMatchByChutaikyoInsurance(
        selectedStatus.key,
        NOT_JOINED
      ),
    };
  } else {
    return {
      presence: false,
      exclusion: false,
    };
  }
};

// 想定外のstatusやkeyがないかチェックし、一致していればtrueを返す
const statusMatch = (status, key) => {
  switch (status) {
    case PRESENCE:
    case NONE:
      if (status === key) {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
};

const statusMatchByJoinPattern = (status, key) => {
  switch (status) {
    case JOIN:
    case NOT_JOINED:
      if (status === key) {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
};

/**
 * 健康、年金、雇用保険用
 * statusはAPIからの返り値で含むものを対象とする
 */
const statusMatchWithExclusion = (status, key) => {
  switch (status) {
    case PRESENCE:
    case EXCLUSION:
    case NONE:
      if (status === key) {
        return true;
      }
      break;
    default:
      return false;
  }
  return false;
};

/**
 * 労災保険特別加入状況
 */
const statusMatchByWorkmansCompensationInsurance = (status, key) => {
  return statusMatch(status, key);
};

/**
 * 建退共制度加入状況
 */
const statusMatchByKentaikyoInsurance = (status, key) => {
  return statusMatchByJoinPattern(status, key);
};
/**
 * 中退共制度加入状況
 */
const statusMatchByChutaikyoInsurance = (status, key) => {
  return statusMatchByJoinPattern(status, key);
};

// 許可元区分名が「知事」かを判定
export const showPrefectureInput = permittedSourceSection => {
  if (permittedSourceSection) {
    const PREFECTURAL_GOVERNOR_ID = 2;
    if (Number(permittedSourceSection) === PREFECTURAL_GOVERNOR_ID) {
      return true;
    }
  }
};

//「都道府県」で「北海道」を選択されているか判定
export const showRegionalDevelopmentBureau = prefectureId => {
  if (
    String(prefectureId) ===
    String(PREFECTURE_GROUPS.hokkaido_tohoku.prefectures.hokkaido.id)
  ) {
    return true;
  }
  return false;
};

const getErrorPropertyMessageByNameKey = nameKey => {
  switch (nameKey) {
    case 'building_name':
      return '建物名・部屋番号等';
    case 'delegate_name':
      return '代表者情報 代表者名';
    case 'delegate_post':
      return '代表者情報 代表者役職';
    case 'authorized_industry_names':
      return '許可情報 許可業種名';
    case 'prefectures_code_id':
      return '許可情報 都道府県';
    case 'regional_development_bureau_id':
      return '許可情報 振興局';
    case 'construction_industry_permission_section':
      return '許可情報 建設許可区分名';
    case 'license_update_date':
      return '許可情報 許可（更新）年月日';
    case 'permission_number_l':
      return '許可情報 許可番号 年度';
    case 'permission_number_r':
      return '許可情報 許可番号 固有番号';
    case 'permitted_source_section':
      return '許可情報 許可元区分名';
    case 'license_date':
      return '許可情報 許可取得年月日';
    case 'health_insurance_flag':
      return '健康保険情報 加入状況';
    case 'health_insurance_type':
      return '健康保険情報 保険種類';
    case 'health_insurance_name_insurer':
      return '健康保険情報 保険者名称';
    case 'health_insurance_office_symbol':
      return '健康保険情報 事業所整理記号';
    case 'health_insurance_office_number':
      return '健康保険情報 事業所番号';
    case 'health_insurance_reason_exclusion':
      return '健康保険情報 適用除外理由';
    case 'pension_flag':
      return '年金保険情報 加入状況';
    case 'pension_type':
      return '年金保険情報 保険種類';
    case 'pension_office_symbol':
      return '年金保険情報 事業所整理記号';
    case 'pension_office_number':
      return '年金保険情報 事業所番号';
    case 'pension_reason_exclusion':
      return '年金保険情報 適用除外理由';
    case 'employment_insurance_flag':
      return '雇用保険情報 加入状況';
    case 'employment_insurance_insurance_number':
      return '雇用保険情報 労働保険番号';
    case 'employment_insurance_exclusions':
      return '雇用保険情報 適用除外理由';
    case 'employment_insurance_reason_exclusion':
      return '雇用保険情報 適用除外理由';
    case 'worker_compensation_flag':
      return '保険情報 労災保険特別加入状況';
    case 'worker_compensation_number':
      return '保険情報 労災保険特別加入労働保険番号';
    case 'worker_compensation_organize_number':
      return '保険情報 労災保険特別加入整理番号';
    case 'const_subscription_flag':
      return '保険情報 建退共制度加入状況';
    case 'const_subscription_number':
      return '保険情報 建退共契約者番号';
    case 'enterprise_subscription_flag':
      return '保険情報 中退共制度加入状況';
    case 'enterprise_subscription_number':
      return '保険情報 中退共契約者番号';
    case 'other_subscription_flag':
      return '退職金共済情報 その他退職金共済制度加入状況';
    case 'other_subscription_name	':
      return '退職金共済情報 その他退職金共済制度名称';
    case 'certification_number':
      return '外国人就労者情報 適正監理計画認定番号';
    case 'supervisor_position_name':
      return '外国人就労者情報 受入監理責任者役職名';
    case 'supervisor_tel':
      return '外国人就労者情報 受入監理責任者電話番号';
    case 'work_place':
      return '外国人就労者情報 就労場所';
    case 'engagement_content':
      return '外国人就労者情報 従事業務内容';
    case 'work_category':
      return '外国人就労者情報 業務区分';
    case 'engagement_start_date':
      return '外国人就労者情報 従事開始年月日 (計画期間)';
    case 'engagement_end_date':
      return '外国人就労者情報 従事終了年月日 (計画期間)';
    case 'supervisor_name':
      return '外国人就労者情報 受入監理責任者名';
    case 'acceptance_foreign_workers_flag':
      return '外国人就労者情報 外国人就労者受入有無';
    case 'license_limit_date':
      return 'その他許可情報 有効期限年月日';
    default:
      return '';
  }
};

const addErrorMessages = (messages, key) => {
  const errorMessages = [];
  Object.keys(messages[key]).forEach(item => {
    if (getErrorPropertyMessageByNameKey(item) !== '') {
      errorMessages.push(getErrorPropertyMessageByNameKey(item));
    }
  });
  return errorMessages;
};

const addErrorMessagesForCompanyBranchPermissions = messageObject => {
  const errorMessages = [];
  Object.keys(messageObject).forEach(item => {
    if (getErrorPropertyMessageByNameKey(item) !== '') {
      errorMessages.push(getErrorPropertyMessageByNameKey(item));
    }
  });
  return errorMessages;
};

const addArrayErrorMessages = (messages, subKey) => {
  const errorMessages = [];
  if (getErrorPropertyMessageByNameKey(subKey) !== '') {
    errorMessages.push(getErrorPropertyMessageByNameKey(subKey));
  }
  return errorMessages;
};

export const createErrorMessageList = messages => {
  const errorMessages = [];
  Object.keys(messages).forEach(key => {
    switch (key) {
      case 'company_branch_insurance':
      case 'company_branch_foreigner':
      case 'company_detail':
        errorMessages.push(...addErrorMessages(messages, key));
        break;
      case 'company_branch_permissions':
        Object.values(messages[key]).forEach(messageObject => {
          errorMessages.push(
            ...addErrorMessagesForCompanyBranchPermissions(messageObject)
          );
        });
        break;
      case 'other_company_branch_permission_groups':
        let foundMessage = false;
        Object.values(messages[key]).forEach((item, index) => {
          if (typeof item === 'object' && item !== null) {
            Object.keys(item).forEach((subKey, subIndex) => {
              if (typeof item[subKey] === 'string') {
                // 一つでもバリデーションエラーになった場合、エラー項目を1回のみ表示する
                if (!foundMessage) {
                  errorMessages.push(addArrayErrorMessages(messages, subKey));
                  foundMessage = true;
                }
              }
            });
          }
        });
        break;
      default:
        const errorPropertyMessage = getErrorPropertyMessageByNameKey(key);
        if (errorPropertyMessage !== '') {
          errorMessages.push(errorPropertyMessage);
        }
        break;
    }
  });
  return errorMessages;
};

export const partnerCompanyFindStatus = (type, targetValue, checkboxList) => {
  const fromInsuranceStatuses = targetValue => {
    if (!_.isEmpty(checkboxList.insurance_statuses)) {
      return checkboxList.insurance_statuses.find(
        item => item.value === targetValue
      );
    }
    return null;
  };
  const fromWorkmansCompensationInsuranceStatuses = targetValue => {
    if (!_.isEmpty(checkboxList.workmans_compensation_insurance_statuses)) {
      return checkboxList.workmans_compensation_insurance_statuses.find(
        item => item.value === targetValue
      );
    }
    return null;
  };
  const fromKentaikyoInsuranceStatuses = targetValue => {
    if (!_.isEmpty(checkboxList.kentaikyo_insurance_statuses)) {
      return checkboxList.kentaikyo_insurance_statuses.find(
        item => item.value === targetValue
      );
    }
    return null;
  };
  const fromChutaikyoInsuranceStatuses = targetValue => {
    if (!_.isEmpty(checkboxList.chutaikyo_insurance_statuses)) {
      return checkboxList.kentaikyo_insurance_statuses.find(
        item => item.value === targetValue
      );
    }
    return null;
  };
  switch (type) {
    case INSURANCE_STATUS:
    case HEALTH_INSURANCE_FLAG:
    case PENSION_FLAG:
    case EMPLOYMENT_INSURANCE_FLAG:
      return fromInsuranceStatuses(targetValue);
    case WORKER_COMPENSATION_FLAG:
      return fromWorkmansCompensationInsuranceStatuses(targetValue);
    case CONST_SUBSCRIPTION_FLAG:
      return fromKentaikyoInsuranceStatuses(targetValue);
    case ENTERPRISE_SUBSCRIPTION_FLAG:
      return fromChutaikyoInsuranceStatuses(targetValue);
    default:
      return null;
  }
};
export const getCompanyBranchPermissionsErrorMsg = (
  message,
  targetName,
  constructionIndustryPermissionIndex,
  companyBranchPermissionResult
) => {
  let newErrorMessage = _.cloneDeep(message);
  if (!message) {
    newErrorMessage = [];
  }

  // 建設業許可有無の切り替えはバリデーションの結果を使用する
  if (targetName === 'construction_industry_permission_flag') {
    return companyBranchPermissionResult;
  }

  /**
   * 他indexの建設魚許可証でエラーがあり、判定対象ではエラーがない場合
   * 判定対象のindex、あるいは判定対象のエラーメッセージを取り除く
   *  */
  if (
    !companyBranchPermissionResult[constructionIndustryPermissionIndex] ||
    !companyBranchPermissionResult[constructionIndustryPermissionIndex][
      targetName
    ]
  ) {
    newErrorMessage = inCaseOfValidationErrorsInOtherIndexes(
      newErrorMessage,
      targetName,
      constructionIndustryPermissionIndex
    );
    newErrorMessage = getCompanyBranchPermissionEmptyErrorMessage(
      newErrorMessage
    );
    if (targetName !== 'permitted_source_section') {
      return newErrorMessage;
    }
  }

  switch (targetName) {
    case 'prefectures_code_id':
      newErrorMessage = formatPrefectureCodeIdErrorMsg(
        newErrorMessage,
        constructionIndustryPermissionIndex,
        companyBranchPermissionResult
      );
      break;
    case 'permitted_source_section':
      newErrorMessage = formatPermittedSourceSectionErrorMsg(
        newErrorMessage,
        constructionIndustryPermissionIndex
      );
      break;
    default:
      if (
        constructionIndustryPermissionIndex !== undefined &&
        constructionIndustryPermissionIndex !== null
      ) {
        newErrorMessage = defaultFormatCompanyBranchPermissionErrorMsg(
          newErrorMessage,
          targetName,
          constructionIndustryPermissionIndex,
          companyBranchPermissionResult
        );
      }
      break;
  }
  newErrorMessage = getCompanyBranchPermissionEmptyErrorMessage(
    newErrorMessage
  );
  return newErrorMessage;
};

const inCaseOfValidationErrorsInOtherIndexes = (
  message,
  targetName,
  constructionIndustryPermissionIndex
) => {
  let newErrorMessage = _.cloneDeep(message);

  if (
    newErrorMessage[constructionIndustryPermissionIndex] &&
    newErrorMessage[constructionIndustryPermissionIndex][targetName]
  ) {
    delete newErrorMessage[constructionIndustryPermissionIndex][targetName];
  }

  return newErrorMessage;
};

const formatPrefectureCodeIdErrorMsg = (
  message,
  constructionIndustryPermissionIndex,
  companyBranchPermissionResult
) => {
  const targetName = 'prefectures_code_id';
  let newErrorMessage = _.cloneDeep(message);

  if (constructionIndustryPermissionIndex !== null) {
    if (
      companyBranchPermissionResult[constructionIndustryPermissionIndex] ===
        undefined &&
      _.has(
        newErrorMessage,
        `[${constructionIndustryPermissionIndex}][${targetName}]`
      )
    ) {
      delete newErrorMessage[constructionIndustryPermissionIndex][targetName];
    } else {
      newErrorMessage[constructionIndustryPermissionIndex] =
        companyBranchPermissionResult[constructionIndustryPermissionIndex];
    }
    newErrorMessage = getCompanyBranchPermissionEmptyErrorMessage(
      newErrorMessage
    );
  }
  return newErrorMessage;
};

const formatPermittedSourceSectionErrorMsg = (
  message,
  constructionIndustryPermissionIndex
) => {
  let newErrorMessage = _.cloneDeep(message);

  // 該当indexの都道府県にエラーがあった時に消す
  if (
    newErrorMessage[constructionIndustryPermissionIndex] !== undefined &&
    newErrorMessage[constructionIndustryPermissionIndex]['prefectures_code_id']
  ) {
    delete newErrorMessage[constructionIndustryPermissionIndex][
      'prefectures_code_id'
    ];
  }
  return newErrorMessage;
};

const defaultFormatCompanyBranchPermissionErrorMsg = (
  message,
  targetName,
  constructionIndustryPermissionIndex,
  companyBranchPermissionResult
) => {
  let newErrorMessage = _.cloneDeep(message);
  const errorMsg =
    _.get(
      companyBranchPermissionResult,
      `[${constructionIndustryPermissionIndex}][${targetName}]`,
      ''
    ) || '';
  if (errorMsg === '') {
    return newErrorMessage;
  }

  if (newErrorMessage[constructionIndustryPermissionIndex] !== undefined) {
    newErrorMessage[constructionIndustryPermissionIndex] = {
      ...newErrorMessage[constructionIndustryPermissionIndex],
      [targetName]:
        companyBranchPermissionResult[constructionIndustryPermissionIndex][
          targetName
        ],
    };
  } else {
    newErrorMessage[constructionIndustryPermissionIndex] = {
      [targetName]:
        companyBranchPermissionResult[constructionIndustryPermissionIndex][
          targetName
        ],
    };
  }
  return newErrorMessage;
};

const getCompanyBranchPermissionEmptyErrorMessage = message => {
  let emptyFlg = true;
  let newErrorMessage = _.cloneDeep(message);
  for (const item in newErrorMessage) {
    if (newErrorMessage[item] !== undefined) {
      const validateObject = newErrorMessage[item];
      if (Object.keys(validateObject).length > 0) {
        emptyFlg = false;
      }
    }
  }
  if (emptyFlg) {
    return [];
  }
  return newErrorMessage;
};

export const deleteCompanyBranchPermissionsErrorMsgByIndex = (
  message,
  constructionIndustryPermissionIndex
) => {
  let baseMessages = _.cloneDeep(message);
  let newErrorMessage = [];

  for (const index in baseMessages) {
    if (index !== String(constructionIndustryPermissionIndex)) {
      newErrorMessage.push(baseMessages[index]);
    }
  }

  return newErrorMessage;
};

export const filterComboBoxHealthInsuranceTypeWhenExist = comboBoxHealthInsuranceType => {
  let newComboBoxHealthInsuranceType = _.cloneDeep(comboBoxHealthInsuranceType);
  const required = ['健康保険組合', '協会けんぽ（全国健康保険協会）'];
  newComboBoxHealthInsuranceType = _.filter(
    comboBoxHealthInsuranceType,
    item => {
      return _.includes(required, item.name);
    }
  );
  return newComboBoxHealthInsuranceType;
};

export const filterComboBoxHealthInsuranceTypeWhenExclusion = (
  comboBoxHealthInsuranceType,
  reason
) => {
  let newComboBoxHealthInsuranceType = _.cloneDeep(comboBoxHealthInsuranceType);
  let required;
  switch (reason) {
    case 'けんぽ適用除外承認済':
      required = ['国民健康保険組合'];
      break;
    case '５人未満個人事業所':
      required = ['国民健康保険組合', '国民健康保険'];
      break;
    default:
      break;
  }
  newComboBoxHealthInsuranceType = _.filter(
    comboBoxHealthInsuranceType,
    item => {
      return _.includes(required, item.name);
    }
  );
  return newComboBoxHealthInsuranceType;
};

export const filterComboBoxPensionInsuranceTypeWhenExist = pensionInsuranceTypesComboBoxList => {
  let newPensionInsuranceTypesComboBoxList = _.cloneDeep(
    pensionInsuranceTypesComboBoxList
  );
  const required = ['厚生年金'];
  newPensionInsuranceTypesComboBoxList = _.filter(
    pensionInsuranceTypesComboBoxList,
    item => {
      return _.includes(required, item.name);
    }
  );
  return newPensionInsuranceTypesComboBoxList;
};

export const filterComboBoxPensionInsuranceTypeWhenExclusion = pensionInsuranceTypesComboBoxList => {
  let newPensionInsuranceTypesComboBoxList = _.cloneDeep(
    pensionInsuranceTypesComboBoxList
  );
  const required = ['国民年金'];
  newPensionInsuranceTypesComboBoxList = _.filter(
    pensionInsuranceTypesComboBoxList,
    item => {
      return _.includes(required, item.name);
    }
  );
  return newPensionInsuranceTypesComboBoxList;
};

const cleanupHealthInsuranceValues = companyBranchInsurance => {
  const newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
  if (newCompanyBranchInsurance['health_insurance_type'] === 'その他') {
    newCompanyBranchInsurance['health_insurance_type'] =
      newCompanyBranchInsurance['health_insurance_type_other'];
    delete newCompanyBranchInsurance['health_insurance_type_other'];
  }

  if (
    newCompanyBranchInsurance['health_insurance_reason_exclusion'] === 'その他'
  ) {
    newCompanyBranchInsurance['health_insurance_reason_exclusion'] =
      newCompanyBranchInsurance['health_insurance_reason_exclusion_other'];
    delete newCompanyBranchInsurance['health_insurance_reason_exclusion_other'];
  }

  // 加入状況が無の時
  if (
    newCompanyBranchInsurance['health_insurance_flag'] ===
    EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID
  ) {
    newCompanyBranchInsurance['health_insurance_name_insurer'] = '';
    newCompanyBranchInsurance['health_insurance_office_number'] = '';
    newCompanyBranchInsurance['health_insurance_office_symbol'] = '';
    newCompanyBranchInsurance['health_insurance_type'] = '';
    newCompanyBranchInsurance['health_insurance_type_code'] = '';

    newCompanyBranchInsurance['health_insurance_reason_exclusion'] = '';
    newCompanyBranchInsurance['ccus_health_insurance_reason_exclusion_code'] =
      '';
  }
  if (
    newCompanyBranchInsurance['health_insurance_flag'] ===
      EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID &&
    newCompanyBranchInsurance['health_insurance_reason_exclusion'] ===
      '５人未満個人事業所' &&
    newCompanyBranchInsurance['health_insurance_type'] === '国民健康保険'
  ) {
    newCompanyBranchInsurance['health_insurance_name_insurer'] = '';
    newCompanyBranchInsurance['health_insurance_office_number'] = '';
    newCompanyBranchInsurance['health_insurance_office_symbol'] = '';
  }
  return newCompanyBranchInsurance;
};
const cleanupPensionValues = companyBranchInsurance => {
  const newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
  if (newCompanyBranchInsurance['pension_type'] === 'その他') {
    newCompanyBranchInsurance['pension_type'] =
      newCompanyBranchInsurance['pension_type_other'];
    delete newCompanyBranchInsurance['pension_type_other'];
  }

  if (newCompanyBranchInsurance['pension_reason_exclusion'] === 'その他') {
    newCompanyBranchInsurance['pension_reason_exclusion'] =
      newCompanyBranchInsurance['pension_reason_exclusion_other'];
    delete newCompanyBranchInsurance['pension_reason_exclusion_other'];
  }
  // 加入状況が無の時
  if (
    newCompanyBranchInsurance['pension_flag'] ===
    EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID
  ) {
    newCompanyBranchInsurance['pension_office_number'] = '';
    newCompanyBranchInsurance['pension_office_symbol'] = '';
    newCompanyBranchInsurance['pension_type'] = '';
    newCompanyBranchInsurance['pension_type_code'] = '';

    newCompanyBranchInsurance['pension_reason_exclusion'] = '';
    newCompanyBranchInsurance['ccus_pension_reason_exclusion_code'] = '';
  }
  if (
    newCompanyBranchInsurance['pension_flag'] ===
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    newCompanyBranchInsurance['pension_reason_exclusion'] = '';
    newCompanyBranchInsurance['ccus_pension_reason_exclusion_code'] = '';
  }

  // otherが残っている場合は削除する
  if (_.has(newCompanyBranchInsurance, 'pension_type_other')) {
    delete newCompanyBranchInsurance['pension_type_other'];
  }

  return newCompanyBranchInsurance;
};
const cleanupEmploymentInsuranceValues = companyBranchInsurance => {
  const newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
  if (
    newCompanyBranchInsurance['employment_insurance_reason_exclusion'] ===
    'その他'
  ) {
    newCompanyBranchInsurance['employment_insurance_reason_exclusion'] =
      newCompanyBranchInsurance['employment_insurance_reason_exclusion_other'];
    delete newCompanyBranchInsurance[
      'employment_insurance_reason_exclusion_other'
    ];
  }

  if (
    newCompanyBranchInsurance['employment_insurance_flag'] !==
    EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    newCompanyBranchInsurance['employment_insurance_insurance_number'] = '';
  }

  return newCompanyBranchInsurance;
};

const cleanupWorkerAddOnCompensationValues = (
  companyBranchInsurance,
  isPartner = true
) => {
  const newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);

  if (
    isWorkerAddOnCompensationStatus(
      newCompanyBranchInsurance.worker_add_on_compensation_flag
    ) &&
    isPartner
  ) {
    if (
      isNullOrUndefinedOrEmptyStr(
        newCompanyBranchInsurance['worker_add_on_compensation_amount']
      )
    ) {
      newCompanyBranchInsurance['worker_add_on_compensation_amount'] = '';
    } else {
      newCompanyBranchInsurance[
        'worker_add_on_compensation_amount'
      ] = _.toNumber(
        newCompanyBranchInsurance['worker_add_on_compensation_amount']
      );
    }
  } else {
    newCompanyBranchInsurance['worker_add_on_compensation_start_date'] = '';
    newCompanyBranchInsurance['worker_add_on_compensation_end_date'] = '';
    newCompanyBranchInsurance['worker_add_on_compensation_amount'] = '';
    newCompanyBranchInsurance['worker_add_on_compensation_company_name'] = '';
    newCompanyBranchInsurance['worker_add_on_compensation_number'] = '';
  }

  return newCompanyBranchInsurance;
};

export const cleanupBeforeUpdateUtil = {
  cleanupHealthInsuranceValues,
  cleanupPensionValues,
  cleanupEmploymentInsuranceValues,
  cleanupWorkerAddOnCompensationValues,
};

const checkExistDataByHealthInsurance = companyBranchInsurance => {
  const noticeData = [];
  let unusedKeys = [];
  // 加入状況 未選択
  if (
    isNullOrUndefinedOrEmptyStr(companyBranchInsurance.health_insurance_flag)
  ) {
    unusedKeys = [
      'health_insurance_type',
      'health_insurance_name_insurer',
      'health_insurance_office_symbol',
      'health_insurance_office_number',
      'health_insurance_reason_exclusion',
    ];
  }

  switch (companyBranchInsurance.health_insurance_flag) {
    case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
      // 無
      unusedKeys = [
        'health_insurance_type',
        'health_insurance_name_insurer',
        'health_insurance_office_symbol',
        'health_insurance_office_number',
        'health_insurance_reason_exclusion',
      ];
      break;
    case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
      // 無
      unusedKeys = ['health_insurance_reason_exclusion'];
      break;
    case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
      // 適用除外
      if (companyBranchInsurance.health_insurance_type === '国民健康保険') {
        unusedKeys = [
          'health_insurance_name_insurer',
          'health_insurance_office_symbol',
          'health_insurance_office_number',
        ];
      }
      break;
    default:
      break;
  }

  for (const item of unusedKeys) {
    if (!isNullOrUndefinedOrEmptyStr(companyBranchInsurance[item])) {
      noticeData.push(item);
    }
  }

  // 重複を排除して返す
  return [...new Set(noticeData)];
};

const checkExistDataByPension = companyBranchInsurance => {
  const noticeData = [];

  // 加入状況 未選択
  if (isNullOrUndefinedOrEmptyStr(companyBranchInsurance.pension_flag)) {
    const unusedKeys = [
      'pension_reason_exclusion',
      'pension_type',
      'pension_office_symbol',
      'pension_office_number',
    ];

    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(companyBranchInsurance[item])) {
        noticeData.push(item);
      }
    }
  }

  // 無
  if (
    companyBranchInsurance.pension_flag === EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID
  ) {
    const unusedKeys = [
      'pension_reason_exclusion',
      'pension_type',
      'pension_office_symbol',
      'pension_office_number',
    ];
    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(companyBranchInsurance[item])) {
        noticeData.push(item);
      }
    }
  }

  //  有
  if (
    companyBranchInsurance.pension_flag === EXISTANCE_EXCLUSION_FLAG.EXIST.ID
  ) {
    const unusedKeys = ['pension_reason_exclusion'];
    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(companyBranchInsurance[item])) {
        // if (item === 'pension_type') {
        //   if (companyBranchInsurance['pension_type'] !== '厚生年金') {
        //     noticeData.push('pension_type_exist');
        //   }
        // } else {
        noticeData.push(item);
        // }
      }
    }
  }

  // 適用除外理由
  if (
    companyBranchInsurance.pension_flag ===
    EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID
  ) {
    // 該当なし
    const unusedKeys = ['pension_office_symbol', 'pension_office_number'];
    for (const item of unusedKeys) {
      if (!isNullOrUndefinedOrEmptyStr(companyBranchInsurance[item])) {
        // if (item === 'pension_type') {
        //   if (companyBranchInsurance['pension_type'] !== '国民年金') {
        //     noticeData.push('pension_type_exclusion');
        //   }
        // } else {
        noticeData.push(item);
        // }
      }
    }
  }

  // 重複を排除する
  return [...new Set(noticeData)];
};

const checkExistDataByEmployment = insuranceInfo => {
  const noticeData = [];
  let unusedKeys = [];

  // 加入状況 未選択
  if (isNullOrUndefinedOrEmptyStr(insuranceInfo.employment_insurance_flag)) {
    unusedKeys = [
      'employment_insurance_insurance_number',
      'employment_insurance_reason_exclusion',
    ];
  }

  switch (insuranceInfo.employment_insurance_flag) {
    case EXISTANCE_EXCLUSION_FLAG.NOEXIST.ID:
      // 無
      unusedKeys = [
        'employment_insurance_insurance_number',
        'employment_insurance_reason_exclusion',
      ];
      break;
    case EXISTANCE_EXCLUSION_FLAG.EXIST.ID:
      // 有
      unusedKeys = ['employment_insurance_reason_exclusion'];
      break;
    case EXISTANCE_EXCLUSION_FLAG.EXCLUSION.ID:
      // 適用除外
      unusedKeys = ['employment_insurance_insurance_number'];
      break;
    default:
      break;
  }

  for (const item of unusedKeys) {
    if (!isNullOrUndefinedOrEmptyStr(insuranceInfo[item])) {
      noticeData.push(item);
    }
  }

  // 重複を排除する
  return [...new Set(noticeData)];
};

export const checkExistData = companyBranchInsurance => {
  const healthInsuranceData = checkExistDataByHealthInsurance(
    companyBranchInsurance
  );
  const pensionData = checkExistDataByPension(companyBranchInsurance);
  const employmentData = checkExistDataByEmployment(companyBranchInsurance);
  return {
    healthInsurance: [...healthInsuranceData],
    pensionInsurance: [...pensionData],
    employmentInsurance: [...employmentData],
  };
  // return {
  //   healthInsurance: [],
  //   pensionInsurance: [],
  //   employmentInsurance: [],
  // };
};

export const showAskForFlagUpdateDialog = ({
  requestUserFixListByHealthInsurance,
  requestUserFixListByPensionInsurance,
  requestUserFixListByEmploymentInsurance,
  companyBranchInsurance,
}) => {
  let message = '';

  if (
    requestUserFixListByHealthInsurance.length > 0 &&
    isNullOrUndefinedOrEmptyStr(companyBranchInsurance.health_insurance_flag)
  ) {
    message += '健康保険の加入状況を設定してください。\n';
  }
  if (
    requestUserFixListByPensionInsurance.length > 0 &&
    isNullOrUndefinedOrEmptyStr(companyBranchInsurance.pension_flag)
  ) {
    message += '年金の加入状況を設定してください。\n';
  }
  if (
    requestUserFixListByEmploymentInsurance.length > 0 &&
    isNullOrUndefinedOrEmptyStr(
      companyBranchInsurance.employment_insurance_flag
    )
  ) {
    message += '雇用保険の加入状況を設定してください。\n';
  }
  message +=
    '\n未選択のままでは更新することができません。\n詳細は閉じるボタン押下後、赤枠内のメッセージをご確認ください。';

  dialogLoader.show(FormInformationDialog, {
    title: '登録情報の確認をお願いします',
    message,
    onClose: () => {
      dialogLoader.close();
    },
  });
};

export const hasRequestUserFixList = ({
  requestUserFixListByHealthInsurance = [],
  requestUserFixListByPensionInsurance = [],
  requestUserFixListByEmploymentInsurance = [],
}) => {
  if (
    requestUserFixListByHealthInsurance.length > 0 ||
    requestUserFixListByPensionInsurance.length > 0 ||
    requestUserFixListByEmploymentInsurance.length > 0
  ) {
    return true;
  }
  return false;
};

/**
 *
 {employment_insurance_type: "一般", employment_insura…}
:

 */

const valueNotInComboBox = (value, name, comboBoxList) => {
  const fullComboList = _.concat(comboBoxList, { [name]: '' });
  return !_.find(fullComboList, item => {
    return item[value] === name;
  });
};

// combobox種類により、データの構造が異なる。協力会社の健康保険種類などに対応。
const valueNotInComboBoxForType = (value, comboBoxList) => {
  const result = comboBoxList.find(item => {
    return item.name === value;
  });
  if (!result) {
    return true;
  }
  return false;
};
const valueNotInComboBoxForReasonExclusion = (value, comboBoxList) => {
  const result = comboBoxList.find(item => {
    return item.tekiyoujogai_reason === value;
  });
  if (!result) {
    return true;
  }
  return false;
};

export const setInputOrSelectionForType = (
  companyBranchInsurance,
  name,
  comboBoxList
) => {
  return setInputOrSelection(
    companyBranchInsurance,
    name,
    comboBoxList,
    valueNotInComboBoxForType
  );
};

export const setInputOrSelectionForReasonExclusion = (
  companyBranchInsurance,
  name,
  comboBoxList
) => {
  return setInputOrSelection(
    companyBranchInsurance,
    name,
    comboBoxList,
    valueNotInComboBoxForReasonExclusion
  );
};

// 適用除外理由などで選択項目が「その他」の場合は入力項目を表示・編集可能、そして入力値が選択可能な場合自動で設定する
export const setInputOrSelection = (
  companyBranchInsurance,
  name,
  comboBoxList,
  valueExistsFn = valueNotInComboBoxForType
) => {
  const newCompanyBranchInsurance = _.cloneDeep(companyBranchInsurance);
  if (
    !isNullOrUndefinedOrEmptyStr(newCompanyBranchInsurance[name]) &&
    valueExistsFn(newCompanyBranchInsurance[name], comboBoxList)
  ) {
    // 初回読み込み
    if (newCompanyBranchInsurance[name] !== 'その他') {
      newCompanyBranchInsurance[`${name}_other`] =
        newCompanyBranchInsurance[name];
      newCompanyBranchInsurance[name] = 'その他';
    } else {
      // type_otherがselectの値になっている時はtypeに値を写して、other消す
      if (
        !valueExistsFn(
          newCompanyBranchInsurance[`${name}_other`],
          comboBoxList
        ) &&
        newCompanyBranchInsurance[`${name}_other`] !== ''
      ) {
        newCompanyBranchInsurance[name] =
          newCompanyBranchInsurance[`${name}_other`];
        newCompanyBranchInsurance[`${name}_other`] = '';
      }
    }
  }
  return newCompanyBranchInsurance;
};

export const isHasOtherIndustryPermission = value =>
  Number(value) === EXISTANCE_FLAG.EXIST.VALUE;

export const concatOtherIndustryPermissionGroupsSubmit = values => {
  let {
    company_detail: companyDetail,
    company_branch_permission_groups: companyBranchPermissions,
    other_company_branch_permission_groups: otherIndustryPermissions,
  } = values;

  if (
    isHasOtherIndustryPermission(companyDetail.other_industry_permission_flag)
  ) {
    otherIndustryPermissions = otherIndustryPermissions.map(item => {
      let permission = {
        ...item,
        id: !item.isCreate ? item.id : null,
        company_branch_permission_attributes: {
          authorized_industry_names: item['authorized_industry_names'],
        },
      };
      permission = _.omit(permission, ['authorized_industry_names']);
      return permission;
    });
    companyBranchPermissions = _.concat(
      companyBranchPermissions,
      otherIndustryPermissions
    );
  }

  return companyBranchPermissions;
};

export const concatOtherIndustryPermissionDeleteIds = values => {
  let {
    delete_company_branch_permission_group_ids: deleteCompanyBranchPermissionIds,
    other_company_branch_permission_groups: otherIndustryPermissions,
  } = values;

  if (
    isHasOtherIndustryPermission(
      values.company_detail.other_industry_permission_flag
    )
  ) {
    return deleteCompanyBranchPermissionIds;
  }

  const deleteOtherIndustryPermissionIds = _.map(
    _.filter(otherIndustryPermissions, item => !item.isCreate),
    item => item.id
  );
  return _.concat(
    deleteCompanyBranchPermissionIds,
    deleteOtherIndustryPermissionIds
  );
};

export const getParamCommonCompanyBranchPermission = formValues => {
  const {
    company_branch_permissions,
    company_detail: { construction_industry_permission_flag },
  } = formValues;
  if (
    !isConstructionIndustryPermissionStatus(
      construction_industry_permission_flag
    )
  ) {
    return [];
  }
  return _.map(company_branch_permissions, item => {
    if (!showPrefectureInput(Number(item.permitted_source_section))) {
      item.prefectures_code_id = null;
      item.regional_development_bureau_id = null;
    }
    if (_.get(item, 'isCreate')) {
      item.id = null;
    }
    _.forEach(item.company_branch_permissions, (data, index) => {
      if (data._destroy) {
        data['delete_flag'] = data._destroy;
      }
      item.company_branch_permissions[index] = _.omit(data, '_destroy');
    });

    item.company_branch_permissions_attributes =
      item.company_branch_permissions;
    return item;
  });
};

export const getAllCommonCompanyBranchPermissionId = (formValues, params) => {
  const {
    company_detail: { construction_industry_permission_flag },
    company_branch_permissions,
  } = formValues;
  let ids = [];
  if (
    !isConstructionIndustryPermissionStatus(
      construction_industry_permission_flag
    )
  ) {
    const oldData = _.filter(
      company_branch_permissions,
      item => !_.get(item, 'isCreate')
    );
    ids = _.map(oldData, data => data.id);
  }
  return _.union(params, ids);
};

export const getRequiredColumnsOtherIndustryPermissionChange = (
  otherIndustryPermissionFlag,
  oldColumns = []
) => {
  let columns = _.clone(oldColumns);
  if (!_.includes(columns, 'company_detail.other_industry_permission_flag')) {
    columns.push('company_detail.other_industry_permission_flag');
  }
  if (isHasOtherIndustryPermission(otherIndustryPermissionFlag)) {
    return _.union(columns, ['other_company_branch_permission_groups']);
  }
  return _.pull(columns, 'other_company_branch_permission_groups');
};

const listWorkCategoryValidWords = ['土木', '建築', 'ライフライン', '設備'];

export const isValidWordsWorkCategory = workCategory => {
  return _.some(listWorkCategoryValidWords, word =>
    _.includes(workCategory, word)
  );
};

export const validateCompanyBranchForeignerEngagementPeriod = (messages, foreignerInfo) => {
  if (
    !_.has(messages, 'engagement_start_date') &&
    !_.has(messages, 'engagement_end_date')
  ) {
    const startDate = moment(
      foreignerInfo.engagement_start_date
    );
    const endDate = moment(foreignerInfo.engagement_end_date);
    if (endDate.isBefore(startDate)) {
      return false;
    }
  }
  return true;
};


// WEBPACK FOOTER //
// ./src/utilities/companySafetyUtil.js